import { render, staticRenderFns } from "./PageLabel.vue?vue&type=template&id=2b54b601&"
import script from "./PageLabel.vue?vue&type=script&lang=js&"
export * from "./PageLabel.vue?vue&type=script&lang=js&"
import style0 from "./PageLabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports